import { Box, Typography } from '@mui/material';
import { DataAccordion } from '../../../../../../shared-components/DataAccordion';
import DashboardEmissionsTable from '../../../shared-components/DashboardEmissionsTable'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react';
import { getGroupEmissionsScopeTwo } from '../../../../../../../actions/carbonfootprint-rework/07-emission-factors/01-emission-factors';
import { scopeTwoEmissionColumns, scopeTwoTitle } from '../../../constants/dashboard-constants';


export default function ScopeTwoEmissionsFacilities({ openAccordion, changeAccordion, companyId, groupId, year }) {
    const dispatch = useDispatch()
    const accordionName = 'Scope Two Emissions Facility'
    const groups = useSelector(state => state.carbonFootprintBase.groups);
    const { group } = groups.data.find((group) => (group._id === groupId))
    const columns = scopeTwoEmissionColumns(group)
    const scopeTwoEmissionData = useSelector((state) => (state.emissionFactorsReducer?.groupEmissionsScopeTwo?.data))
    const isLoading = useSelector((state) => (state.emissionFactorsReducer?.groupScopeTwoLoading))

    useEffect(() => {
        if (openAccordion === accordionName) {
            dispatch(getGroupEmissionsScopeTwo(companyId, groupId, year))
        }
    }, [dispatch,
        openAccordion,
        companyId,
        groupId,
        year])

    return (
        <DataAccordion
            title={scopeTwoTitle}
            show={openAccordion === accordionName}
            handleChange={() => changeAccordion(accordionName)}
        >
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: 2 }}>
                <Typography variant='h6'>
                    Scope Two Emissions for {group} in {year}:
                </Typography>
                <DashboardEmissionsTable loading={isLoading} columns={columns} rows={scopeTwoEmissionData} />
            </Box>
        </DataAccordion>
    )
}
